export default __webpack_public_path__ + "images/7fa47bb6befdc143622fe1c8327149b4.svg";